import React from 'react';
import NavMenu from '../Nav/NavMenu';
import Footer from '../footer/Footer';
import EmptySlider from '../sliders/EmptySlider';
import FlightImage from "../../assets/static/support.png";
import { Container, Row, Col, Button } from 'react-bootstrap';
import churchAccountImage from "../../assets/static/business/home_screen.png"; 


function ChurchAccount() {
  return (
    <div>
      <NavMenu></NavMenu>
      <br></br><br></br>
      <EmptySlider 
        title="Church Account? We’ve got you covered." 
        description="Kontriman offers various ways to support your Church Account – through our help center, chat support, and email. Get the assistance you need, anytime and anywhere." 
        imageUrl={FlightImage}
    />
 
 <div>
      <Container fluid className="my-5 bg-custom">
        <Container className='container-padding'>
          <Row className="flex-column flex-md-row">
            {/* Image column */}
            <Col md={6} className="order-2 order-md-1">
              <img
                src={churchAccountImage}
                alt="Church Account"
                className="img-fluid"
              />
            </Col>

            {/* Text column */}
            <Col md={6} className="d-flex align-items-center order-1 order-md-2">
              <div>
                <h1 className='custom_heading'>Church Account with Kontriman</h1>
                <p>
                  Tailored specifically for churches and religious organizations, the Kontriman Church Account helps you manage tithes, offerings, and donations efficiently and transparently.
                </p>
                <p>
                  Benefit from secure fund management, multiple signatories for accountability, and convenient digital banking tools to support your ministry’s financial needs.
                </p>
                <p><strong>Key Features:</strong></p>
                <ul>
                  <li>Secure management of tithes, offerings, and donations</li>
                  <li>Multiple authorized signatories for transparency</li>
                  <li>Easy online access and fund tracking</li>
                  <li>Dedicated support for religious organizations</li>
                  <li>Competitive fees and clear account terms</li>
                </ul>

                <a href="/login">
                  <Button className='custom-button mt-3'>Open a Church Account</Button>
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
    </div>

      <Footer></Footer>
    </div>
  );
}

export default ChurchAccount;
